/**
 * Client id from the signed-in session only (never URL, never .env).
 */
export function resolveEffectiveClientId(session) {
  if (session?.clientId != null && session.clientId !== "") {
    return String(session.clientId);
  }
  return null;
}
